<template>
  <div class="control-wrapper">
    <button @click="toggleMenu" class="toggle-button">
      {{ isMenuVisible ? "隱藏" : "顯示" }}
    </button>

    <section
      class="control-container"
      :class="{ 'menu-visible': isMenuVisible }"
    >
      <h3 class="control-header">供應商帳單明細管理</h3>

      <section class="item-container">
        <section
          class="control-item"
          v-for="(control, key) in controls"
          :key="key"
        >
          <section class="control">
            <span class="item-label">
              {{ control.label }}
            </span>

            <div class="flex-1" v-if="control.inputType === 'date'">
              <flat-pickr
                v-model="controlValue[control.vModel]"
                class="form-control"
                :config="{
                  allowInput: true,
                  altInput: true,
                  altFormat: 'Y-m-d',
                  dateFormat: 'Y-m-d',
                }"
              />
            </div>
            <div class="flex-1" v-else>
              <input
                :class="
                  control.inputType === 'checkbox'
                    ? 'input-checkbox'
                    : 'input-box'
                "
                :type="control.inputType"
                :value="controlValue[control.vModel]"
                :checked="controlValue[control.vModel]"
                @input="setInput($event, control.vModel, control.inputType)"
                @change="setInput($event, control.vModel, control.inputType)"
              />
            </div>
          </section>

          <section class="options-container">
            <section class="options-item">
              <span class="options-title"> Type: </span>

              <span class="options-value">
                {{ control.type }}
              </span>
            </section>

            <section class="options-item">
              <span class="options-title"> Options: </span>

              <span class="options-value">
                {{ control.options }}
              </span>
            </section>
          </section>
        </section>
      </section>

      <b-button
        :disabled="isGenerating"
        class="generate-btn"
        style="margin-bottom: 10px"
        @click="$router.go(-1)"
      >
        返回供應商詳情
      </b-button>
      <button
        :disabled="isGenerating"
        class="generate-btn"
        @click="$emit('generateReport')"
      >
        {{ isGenerating ? "Loading..." : "列印帳單明細" }}
      </button>

      <section class="progress-container">
        <div class="progress-bar">
          <div class="progress" :style="`width: ${progress}%;`" />
        </div>

        <section class="generating-label" v-if="progress !== 0">
          <span class="label-title">
            {{ progress === 100 ? "列印帳單明細完成" : "列印帳單明細中" }}
          </span>

          <span class="label-progress">
            {{ `${progress} %` }}
          </span>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import { BButton } from "bootstrap-vue";
import ability from "@/libs/acl/ability";
import { sanitizeFilename } from "@core/utils/filter";

export default {
  components: {
    BButton,
    flatPickr,
  },
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    billData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ability,
      controls: [
        {
          label: "檔案名稱:",
          type: "String",
          options: "Any String",
          inputType: "text",
          vModel: "filename",
        },
        {
          label: "簽署日期:",
          type: "Date",
          options: "Any Date",
          inputType: "date",
          vModel: "sign_date",
        },
      ],
      isMenuVisible: true,
    };
  },
  mounted() {
    const supplierName = this.billData.supplier ? 
      (this.billData.supplier.name_cn || this.billData.supplier.name) : '供應商';
    const billNumber = this.billData.bill_number || this.billData.id;
    const rawFilename = `${supplierName}_帳單明細_${billNumber}`;
    this.controlValue.filename = sanitizeFilename(rawFilename) + '.pdf';

    this.controlValue.sign_date = this.getDateTime(null, true);
  },

  computed: {
    ...mapFields(["controlValue"]),

    isGenerating() {
      return this.progress !== 0 && this.progress !== 100;
    },
    fileName() {
      return this.billData.bill_number || this.billData.id;
    },
  },
  watch: {
    fileName() {
      const supplierName = this.billData.supplier ? 
        (this.billData.supplier.name_cn || this.billData.supplier.name) : '供應商';
      const billNumber = this.billData.bill_number || this.billData.id;
      const rawFilename = `${supplierName}_帳單明細_${billNumber}`;
      this.controlValue.filename = sanitizeFilename(rawFilename) + '.pdf';
    },
  },

  methods: {
    setInput(e, key, inputType) {
      let value = e.target.value;

      if (inputType === "checkbox") {
        value = e.target.checked;
      }

      if (inputType === "number") {
        value = e.target.value ? parseFloat(e.target.value) : 0;
      }

      this.$set(this.controlValue, key, value);
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    getDateTime(date = null, dateOnly = false) {
      const now = date ? new Date(date) : new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');

      if (dateOnly) {
        return `${year}-${month}-${day}`;
      }

      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
